import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    inject,
    input,
    output,
    model,
    viewChild,
    effect,
    signal,
    computed,
} from '@angular/core';
import { DepositDoiService } from './deposit-doi.service';
import { GrowInAnimation, GrowOutAnimation } from '@exl-ng/mulo-common';
import { TranslateService } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { SharedModule } from '../../../shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { AbstractControl, FormControl } from '@angular/forms';
import { validateDoiFormat } from '../../../shared/validators/doi.validator';
import { finalize } from 'rxjs';

@Component({
    selector: 'esp-deposit-doi',
    templateUrl: './deposit-doi.component.html',
    styleUrls: ['./deposit-doi.component.scss'],
    animations: [GrowInAnimation, GrowOutAnimation],
    imports: [SharedModule, MatFormFieldModule, MatIcon],
})
export class DepositDoiComponent implements OnInit {
    private doiSvc = inject(DepositDoiService);
    private xl8Svc = inject(TranslateService);

    readonly placeholder = input<string>(undefined);
    readonly label = input<string>(undefined);
    readonly hint = input<string>(undefined);
    readonly doi = model<string>(undefined);
    readonly assetType = input<string>(undefined);
    readonly isReserved = model(false);
    readonly isReservable = input(true);
    readonly isRegistered = model(false);
    readonly isAutoPopulated = input(false);
    readonly doiReserved = output<string>();
    readonly doiDismissed = output<void>();
    readonly dismissBtn = viewChild<MatButton>('dismissBtn');
    readonly reserveBtn = viewChild<MatButton>('reserveBtn');
    haveDoiConfigurationPerAssetType = signal(false);
    reserveDoiInProcess = signal(false);
    translatedResourceType = {};
    readonly doiControl = input<AbstractControl>(
        new FormControl(this.doi(), [validateDoiFormat]),
    );
    readonly isReservedDoiButtonVisible = computed(
        () =>
            this.isReservable() &&
            this.haveDoiConfigurationPerAssetType() &&
            !this.doi(),
    );

    constructor() {
        const doiControl = this.doiControl();
        if (doiControl) {
            doiControl.valueChanges.subscribe((value) => this.doi.set(value));
        }
        effect(() => {
            const doi = this.doi();
            doiControl.patchValue(doi);
        });
    }

    ngOnInit() {
        this.checkIfhaveDoiConfigurationPerAssetType();
        this.setTranslatedResourceType();
    }

    checkIfhaveDoiConfigurationPerAssetType() {
        this.doiSvc.haveReservedDoiButton(this.assetType()).subscribe({
            next: (response) => {
                this.haveDoiConfigurationPerAssetType.set(response);
            },
            error: (error) => {
                console.error(error);
                this.haveDoiConfigurationPerAssetType.set(false);
            },
        });
    }

    setTranslatedResourceType() {
        const resourceType = this.assetType() || '_';
        this.xl8Svc.get(resourceType).subscribe((translation: String) => {
            this.translatedResourceType['0'] = translation.toLowerCase();
        });
    }

    requestReserveDoi() {
        this.reserveDoiInProcess.set(true);
        this.doiSvc
            .getNewReserveDoi(this.assetType())
            .pipe(finalize(() => this.reserveDoiInProcess.set(false)))
            .subscribe((newDoi) => {
                this.doiControl().patchValue(newDoi);
                this.isReserved.set(true);
                this.doiReserved.emit(newDoi);
                setTimeout(() => this.dismissBtn().focus());
            });
    }

    dismissDoi() {
        this.doiControl().reset();
        this.isRegistered.set(false);
        this.isReserved.set(false);
        this.doiDismissed.emit();
        setTimeout(() => this.reserveBtn().focus());
    }
}
